import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { ContractStatus, IContract } from "@framework/types";
import {
  ContractSearchForm,
  PaymentSplitterBalanceButton,
  PaymentSplitterContractDeployButton,
  ServiceType,
} from "@framework/shared";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { PaymentSplitterDialogView } from "./view";

const PAYMENT_SPLITTER_CONTRACTS_URL = "/payment-splitter/contracts";
const PAYMENT_SPLITTER_CONTRACTS_DIALOG_KEY = "paymentSplitterContracts";

export const PaymentSplitterContracts = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IContract>
  >(PAYMENT_SPLITTER_CONTRACTS_URL, { enableInfiniteScroll: isMd }, void 0, {
    contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
  });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IContract>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "payment-splitter", "payment-splitter.contracts"]} />

      <PageHeader message="pages.payment-splitter.title">
        <PaymentSplitterContractDeployButton />
      </PageHeader>

      <ContractSearchForm
        service={ServiceType.ADMIN}
        initialSearchValues={{
          contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
        }}
        contractFeaturesOptions={{}}
      />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(contract => (
            <StyledListItem key={contract.id}>
              <List.ItemText sx={{ width: 0.6 }}>{contract.title}</List.ItemText>
              <ListActions>
                <ListActions>
                  <ListAction
                    onClick={handleView(PAYMENT_SPLITTER_CONTRACTS_DIALOG_KEY, contract, "view")}
                    message="form.buttons.view"
                    dataTestId="ContractViewButton"
                    icon={Visibility}
                  />
                  <PaymentSplitterBalanceButton
                    contract={contract}
                    disabled={contract.contractStatus === ContractStatus.INACTIVE}
                  />
                </ListActions>
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <PaymentSplitterDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${PAYMENT_SPLITTER_CONTRACTS_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
